import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Themed dropdown built on Radix (shadcn) Select. Renders div-based options instead
// of native <option>, which prevents the invalid DOM nesting that crashed the app
// (a <span> injected inside <option> desynced React's reconciler -> white screen).
export function TxSelect({
  value, onValueChange, items, placeholder,
  testid, triggerClassName = "", contentClassName = "",
}) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        data-testid={testid}
        className={`bg-[#131722] border border-[#262C3A] text-[#F8FAFC] rounded-xl focus:ring-1 focus:ring-[#FF5500] focus:border-[#FF5500] ${triggerClassName}`}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={`bg-[#131722] border border-[#262C3A] text-[#F8FAFC] z-[70] max-h-72 ${contentClassName}`}>
        {items.map((it) => (
          <SelectItem
            key={it.value}
            value={it.value}
            data-testid={it.testid}
            className="text-[#F8FAFC] focus:bg-[#262C3A] focus:text-white data-[state=checked]:text-[#FF5500] cursor-pointer"
          >
            {it.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
